import { createRoute } from '@tanstack/react-router';
import { lazy } from 'react';
import { authenticatedRoute } from '../_authenticated';

const SchemaListPage = lazy(() =>
  import('@/features/schemas/components/SchemaListPage').then((m) => ({
    default: m.SchemaListPage,
  })),
);

export const schemasRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/schemas',
  component: SchemaListPage,
});
